import React from 'react';
import { MDBContainer, MDBCard, MDBRow, MDBCol, MDBCardBody, MDBCardTitle, MDBCardText, MDBIcon } from 'mdb-react-ui-kit';

const DashboardCard = ({ data }) => {
    return (
        <div>
            <MDBContainer className='mt-4 px-3 sm:px-4 md:px-0'>
                <MDBRow className='g-4'>
                    <MDBCol sm='12' md='4'>
                        <MDBCard style={{ backgroundColor: '#042e2e' }} className='h-100 w-100 text-white shadow-sm'>
                            <MDBCardBody className='d-flex justify-content-between align-items-center p-3 p-xl-4'>
                                <div>
                                    <MDBCardTitle className='text-3xl font-bold mb-1'>
                                        {data?.application_progress ?? 0}
                                    </MDBCardTitle>
                                    <MDBCardText className='text-sm sm:text-base mb-0'>
                                        Application In Progress
                                    </MDBCardText>
                                </div>
                                <div className='ms-3'>
                                    <span className='text-4xl opacity-80'>
                                        <MDBIcon fas icon="hourglass-half" />
                                    </span>
                                </div>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>

                    <MDBCol sm='12' md='4'>
                        <MDBCard className='h-100 w-100 shadow-sm'>
                            <MDBCardBody className='d-flex justify-content-between align-items-center p-3 p-xl-4'>
                                <div>
                                    <MDBCardTitle className='text-3xl font-bold mb-1'>
                                        {data?.application_completed ?? 0}
                                    </MDBCardTitle>
                                    <MDBCardText className='text-sm sm:text-base text-gray-600 mb-0'>
                                        Application Completed
                                    </MDBCardText>
                                </div>
                                <div className='ms-3'>
                                    <span className='text-4xl text-gray-400'>
                                        <MDBIcon fas icon="paste" />
                                    </span>
                                </div>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>

                    <MDBCol sm='12' md='4'>
                        <MDBCard className='h-100 w-100 shadow-sm'>
                            <MDBCardBody className='d-flex justify-content-between align-items-center p-3 p-xl-4'>
                                <div>
                                    <MDBCardTitle className='text-3xl font-bold mb-1'>
                                        0
                                    </MDBCardTitle>
                                    <MDBCardText className='text-sm sm:text-base text-gray-600 mb-0'>
                                        Query Raised
                                    </MDBCardText>
                                </div>
                                <div className='ms-3'>
                                    <span className='text-4xl text-gray-400'>
                                        <MDBIcon far icon="comments" />
                                    </span>
                                </div>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </div>
    )
}

export default DashboardCard;